__turbopack_context__.v({
  "closeButton": "style-module-scss-module__AWG2dq__closeButton",
  "openLinkButton": "style-module-scss-module__AWG2dq__openLinkButton",
  "popupContainer": "style-module-scss-module__AWG2dq__popupContainer",
  "popupWrapper": "style-module-scss-module__AWG2dq__popupWrapper",
  "qrCodeContainer": "style-module-scss-module__AWG2dq__qrCodeContainer",
  "qrCodeImage": "style-module-scss-module__AWG2dq__qrCodeImage",
  "title": "style-module-scss-module__AWG2dq__title",
});
